/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.SidebarBoxes = {
  _toggleExpandBox(event) {
    return $(event.currentTarget).closest('.item-expandable').toggleClass('expanded');
  },

  _toggleViewBox(event) {
    return $(event.currentTarget).siblings('ul').toggleClass('view-all');
  },

  initialize() {
    $(document).on('click', '#tasks-box .toggle-content-btn', _.bind(this._toggleExpandBox, this));
    return $(document).on('click', '#tasks-box .view-toggle', _.bind(this._toggleViewBox, this));
  }
};
